import { categoryConfigs } from '../config/categories';
import { createInitialCategorySession } from './drawWish';

export function createInitialSessions() {
    return categoryConfigs.reduce((acc, category) => {
        acc[category.id] = createInitialCategorySession();
        return acc;
    }, {});
}

export function getSessionByCategory(sessions, categoryId) {
    return sessions[categoryId] ?? createInitialCategorySession();
}

export function updateSessionByCategory(sessions, categoryId, nextSession) {
    return {
        ...sessions,
        [categoryId]: nextSession,
    };
}

export function updateSessionTarget(sessions, categoryId, targetItem) {
    const currentSession = getSessionByCategory(sessions, categoryId);
    return updateSessionByCategory(sessions, categoryId, {
        ...currentSession,
        selectItem: targetItem,
        count: 0,
        wasTargetHit: false,
        mood: targetItem ? 'focused' : currentSession.mood,
    });
}
